import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus, faAddressBook, faDiagramProject, faCircleDollarToSlot, faReceipt,
  faRepeat, faBoxOpen, faCartShopping, faQrcode, faFileLines, faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';

const ICONES = {
  Cliente: faAddressBook,
  Projeto: faDiagramProject,
  Receita: faCircleDollarToSlot,
  Despesa: faReceipt,
  Assinatura: faRepeat,
  Produto: faBoxOpen,
  Compra: faCartShopping,
  Ativo: faQrcode,
  Documento: faFileLines,
};

// "+ Criar" (fase 3 do redesign) — antes era um dropdown simples de texto
// puro ("+ Novo"); agora é um menu no mesmo padrão visual do
// CommandPalette (ícone por item, agrupamento visual), preparando o
// terreno pro item 9/10 do pedido: presença de IA na criação. A entrada
// "Descrever com IA" fica visível mas desabilitada com uma explicação —
// não existe infraestrutura de IA conectada ainda nesta etapa, então não
// simulamos um resultado falso (§10: "não criar mock enganoso").
function QuickCreate({ onSelecionar, modulosHabilitados, permissaoClientes, crmAcessivel }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onClickOutside);
    return () => document.removeEventListener('click', onClickOutside);
  }, []);

  const itens = [
    { label: 'Cliente', destino: 'clientes', visivel: crmAcessivel && permissaoClientes },
    { label: 'Projeto', destino: 'projetos', visivel: modulosHabilitados?.projetos },
    { label: 'Receita', destino: 'financeiro', visivel: modulosHabilitados?.financeiro },
    { label: 'Despesa', destino: 'financeiro', visivel: modulosHabilitados?.financeiro },
    { label: 'Assinatura', destino: 'financeiro', visivel: modulosHabilitados?.financeiro },
    { label: 'Produto', destino: 'estoque', visivel: modulosHabilitados?.estoque },
    { label: 'Compra', destino: 'estoque', visivel: modulosHabilitados?.estoque },
    { label: 'Ativo', destino: 'patrimonio', visivel: modulosHabilitados?.patrimonio },
    { label: 'Documento', destino: 'documentos', visivel: crmAcessivel },
  ].filter((i) => i.visivel);

  if (itens.length === 0) return null;

  return (
    <div className="crm-dropdown" ref={ref}>
      <button className="crm-btn crm-btn-primary crm-btn-sm" onClick={() => setOpen((v) => !v)}>
        <FontAwesomeIcon icon={faPlus} /> Criar
      </button>
      {open && (
        <div className="crm-dropdown-menu crm-quick-create-menu align-left">
          <div className="crm-dropdown-section-label">Criar</div>
          {itens.map((item) => (
            <button
              key={item.label}
              className="crm-dropdown-item"
              onClick={() => { setOpen(false); onSelecionar(item.destino); }}
            >
              <FontAwesomeIcon icon={ICONES[item.label] || faPlus} /> {item.label}
            </button>
          ))}
          <div className="crm-dropdown-divider" />
          <button className="crm-dropdown-item crm-dropdown-item-ai" disabled title="Em preparação — ainda sem infraestrutura de IA conectada">
            <FontAwesomeIcon icon={faWandMagicSparkles} /> Descrever com IA...
            <span className="crm-badge-soon">em breve</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default QuickCreate;
